import axios from 'axios'

export default async () => {
    try {
        //
        const route = process.env.VUE_APP_API_ROUTE.concat(
            '/wh_product_slim?get_all_results=true'
        )
        const response = await axios.get(route)
        //
        return response.data.data
    } catch (error) {
        //
        return error.response.data
    }
}
